import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=242b84f6&lang=pug&"
import script from "./Flight.vue?vue&type=script&lang=js&"
export * from "./Flight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports